import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Section-level Error Boundary - wraps individual page sections
 * so one page crash doesn't take down the entire app.
 */
export class SectionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const section = this.props.section || 'Unknown';
    console.error(`[SectionError] ${section}:`, error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const section = this.props.section || 'this section';
      return (
        <div
          className="flex flex-col items-center justify-center py-16 px-4"
          data-testid={`section-error-${(this.props.section || 'unknown').toLowerCase().replace(/\s/g, '-')}`}
        >
          <div className="h-12 w-12 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
            <AlertTriangle className="h-6 w-6 text-destructive" />
          </div>
          <h3 className="text-lg font-semibold mb-1">Something went wrong</h3>
          <p className="text-sm text-muted-foreground mb-4 text-center max-w-md">
            Failed to load {section}. This won't affect other parts of the app.
          </p>
          <Button variant="outline" size="sm" onClick={this.handleRetry} data-testid="section-error-retry-btn">
            <RefreshCw className="h-4 w-4 mr-2" /> Try Again
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
